'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _paths = require('ifeis-isomorphic/lib/redux/actions/events/paths');

var _paths2 = require('ifeis-isomorphic/lib/redux/actions/adjudicators/paths');

var _paths3 = require('ifeis-isomorphic/lib/redux/actions/scores/paths');

var _paths4 = require('ifeis-isomorphic/lib/redux/actions/comments/paths');

var _paths5 = require('ifeis-isomorphic/lib/redux/actions/dress-checks/paths');

var _ifeisIsomorphic = require('ifeis-isomorphic');

var loading = { loading: true };

exports.default = function (fid, eid, state) {
  if ((0, _paths.participantsOfAnEventAreLoading)(state, eid) || (0, _paths.eventAdjudicatorsAreLoading)(state, eid)) {
    return loading;
  }

  var event = (0, _paths.getEvent)(state, eid).set('adjudicators', (0, _paths2.eventAdjudicators)(state, eid));
  var commentsReleasedToggleName = (!event || event.get('commentsReleased') !== 1) && 'Release Comments?' || 'Comments Released';
  var adjudicators = (0, _paths2.eventAdjudicators)(state, eid);
  var persons = (0, _paths.getParticipantsOfAnEvent)(state, eid);
  var scoreSheets = adjudicators.map(function (a) {
    if ((0, _paths3.eventScoresByAdjudicatorAreLoading)(state, eid, a.get('id'))) {
      return;
    }

    var scores = (0, _paths3.eventScoresByAdjudicator)(state, eid, a.get('id')).map(function (score_ids, pid) {
      return {
        person: pid,
        competitor: state.getIn(['feiseanna', 'persons', fid, pid, 'competitor']),
        scores: score_ids.toJS().map(function (score_id) {
          return (0, _paths3.getScore)(state, score_id).toJS();
        })
      };
    }).toArray().map(function (person) {
      var comments = (0, _paths.getEventComment)(state, eid, a.get('id'), person.person).map(function (cid) {
        return (0, _paths4.getComment)(state, cid);
      });
      var dressCheck = (0, _paths5.getDressCheck)(state, (0, _paths.getEventDressCheck)(state, eid, a.get('id'), person.person));
      return _extends({}, person, {
        comment: !comments.get('loading') && comments.toJS().pop(),
        dressCheck: !dressCheck.get('loading') && dressCheck.toJS()
      });
    });

    return scores;
  });

  var genArray = function genArray(n) {
    return Array.apply(null, { length: n }).map(Number.call, Number);
  };
  var scoresTemplate = void 0;

  var eventJS = event.toJS();
  eventJS.commentsReleased = parseInt(eventJS.commentsReleased);

  var scoreSheetsJS = scoreSheets.toJS();
  var personsJS = persons.toJS();

  if (eventJS.rounds) {
    scoresTemplate = genArray(eventJS.rounds);
  } else if (eventJS.type === 'C') {
    scoresTemplate = genArray(3);
  } else {
    scoresTemplate = genArray(1);
  }

  scoresTemplate = scoresTemplate.map(function (n) {
    return n = { round: n + 1 };
  });

  var scores = new _ifeisIsomorphic.ScoreCalculator(eventJS, personsJS);

  if (scoreSheetsJS.every(function (s) {
    return s;
  })) {
    scoreSheetsJS.map(function (scoreSheet) {
      return scores.addScoresheet(scoreSheet);
    });

    scores.calculate();

    var sortedScoresheets = scores.scoresheets.map(function (s) {
      s.scores.sort(function (a, b) {
        return a.scores[0].created_at - b.scores[0].created_at;
      });
      return s;
    });

    scores.scoresheets = sortedScoresheets;
  }
  var num_placed = scores.numPlaced() || 0;

  return {
    loading: false,
    event: eventJS,
    adjudicators: adjudicators.toJS(),
    persons: personsJS,
    scoreSheets: scoreSheetsJS,
    scores: scores,
    scoresTemplate: scoresTemplate,
    commentsReleasedToggleName: commentsReleasedToggleName,
    num_placed: num_placed
  };
};


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/tabulations/review/mapStateToController.js
// module id = 582
// module chunks = 0